import {
  FetchJaneByIdByIdDataProvider,
  useFetchJaneByIdDataContext,
} from 'components/JaneDetailsModal/FetchJaneById.data.context';
import { JaneDetailsModalComponentMap } from './JaneDetailsModal.constants';
import {
  JaneDetailsModalUIProvider,
  useJaneDetailsModalUIContext,
} from 'components/JaneDetailsModal/JaneDetailsModal.ui.context';
import { JaneDetailsModalTemplate } from './JaneDetailsModalTemplate';
import { FC, Fragment } from 'react';

const ViewComponent: FC = () => {
  const { janeDetailsModalActiveModalView } = useJaneDetailsModalUIContext();
  const { data } = useFetchJaneByIdDataContext();

  const agencyId = data?.agencyCommunity?.id;
  const primaryId = data?.primaryCommunity?.id;
  const primaryJaneCommunityId = agencyId || primaryId;

  const Component = JaneDetailsModalComponentMap[
    janeDetailsModalActiveModalView
  ] as React.ComponentType;

  if (!primaryJaneCommunityId) {
    return <Fragment />;
  }

  return <Component />;
};

const JaneDetailsProviderComponent = () => {
  const { janeDetailsModalActiveModalView, janeId } = useJaneDetailsModalUIContext();
  const Component = JaneDetailsModalComponentMap[
    janeDetailsModalActiveModalView
  ] as React.ComponentType;

  if (!Component) return <Fragment />;

  return (
    <FetchJaneByIdByIdDataProvider janeId={janeId!}>
      <ViewComponent />
    </FetchJaneByIdByIdDataProvider>
  );
};

const JaneDetailsModalComponent = () => {
  return (
    <JaneDetailsModalTemplate>
      <JaneDetailsProviderComponent />
    </JaneDetailsModalTemplate>
  );
};

export const JaneDetailsModal = () => {
  return (
    <JaneDetailsModalUIProvider>
      <JaneDetailsModalComponent />
    </JaneDetailsModalUIProvider>
  );
};
